import { z } from 'zod';
export const apiErrorSchema = z.object({
    error: z.object({
        code: z.string(),
        message: z.string(),
    }),
});
export const ErrorCode = {
    INVALID_INPUT: 'INVALID_INPUT',
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    FORBIDDEN: 'FORBIDDEN',
    INVALID_CSRF: 'INVALID_CSRF',
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    INVALID_UPLOAD: 'INVALID_UPLOAD',
    UPLOAD_TOO_LARGE: 'UPLOAD_TOO_LARGE',
    RATE_LIMITED: 'RATE_LIMITED',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    INVALID_ORIGIN: 'INVALID_ORIGIN',
    INVALID_HOST: 'INVALID_HOST',
    INTERNAL: 'INTERNAL',
};
//# sourceMappingURL=errors.js.map